/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import { MissionDataOutput } from '../backendModels/mission-data.model';

export class MissionDataChangeEvent extends Event {
  change: MissionDataOutput;

  constructor(type: string, newMissionData: MissionDataOutput) {
    super(type, { bubbles: true });

    this.change = newMissionData;
  }
}
